import { render, staticRenderFns } from "./email-verification-2.vue?vue&type=template&id=af5284fe&"
import script from "./email-verification-2.vue?vue&type=script&lang=js&"
export * from "./email-verification-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports